import React from "react";
import MiniHero from "components/miniHero";

const Classes: React.FC = () => {
  return (
    <div>
      <MiniHero image="/images/Gallery/DSC09916.jpg" text="Klasser" />

      {/* Main Content Section */}
      <div className="container mx-auto mt-8 px-8 lg:px-20 py-8">
        <div className="flex flex-col items-center gap-16">
          {/* Left Column - Text Content */}
          <div className="w-full md:w-3/4 text-left">
            {/* Heading */}
            <h1
              className="text-4xl font-bold text-gray-800 mb-6"
              style={{ fontFamily: "'Bebas Neue', sans-serif" }}
            ></h1>

            {/* Introduction */}
            <p
              className="text-lg text-gray-600 mb-6"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
              På Lada Basteskår erbjuder vi ett varierat utbud av klasser som
              passar alla nivåer. Våra klasser är utformade för att vara både
              utmanande och roliga, och vårt mål är att hjälpa dig att nå dina
              träningsmål i en inspirerande miljö.
            </p>

            {/* Class Information */}
            <div className="mb-8">
              <h2
                className="text-2xl font-semibold text-gray-800 mb-4"
                style={{ fontFamily: "'Bebas Neue', sans-serif" }}
              >
                Gruppträning
              </h2>
              <p
                className="text-lg text-gray-600 mb-4"
                style={{ fontFamily: "'IBM Plex Mono', monospace" }}
              >
                Våra gruppträningsklasser fokuserar på funktionell träning där
                vi tränar hela kroppen med inslag av styrka, kondition och
                explosivitet. Oavsett om du är nybörjare eller erfaren, ser vi
                till att du kan träna på din egen nivå.
              </p>
              <ul
                className="list-disc list-inside text-lg text-gray-600 mb-6"
                style={{ fontFamily: "'IBM Plex Mono', monospace" }}
              >
                <li>
                  <strong>Styrkepass:</strong> Förbättra din styrka och teknik
                  genom mångsidiga övningar.
                </li>
                <li>
                  <strong>Konditionspass:</strong> Utmana din uthållighet med
                  högintensiv träning.
                </li>
                <li>
                  <strong>Stretch & Rörlighet:</strong> Fokus på att förbättra
                  flexibilitet och återhämtning.
                </li>
              </ul>
            </div>

            <div className="mb-8">
              <h2
                className="text-2xl font-semibold text-gray-800 mb-4"
                style={{ fontFamily: "'Bebas Neue', sans-serif" }}
              >
                Massage
              </h2>
              <p
                className="text-lg text-gray-600 mb-4"
                style={{ fontFamily: "'IBM Plex Mono', monospace" }}
              >
                Förutom träning erbjuder vi avkopplande och återhämtande
                massage. Detta är perfekt för att minska stress, lösa upp
                spänningar och återhämta kroppen efter intensiv träning.
              </p>
            </div>

            <div className="mb-8">
              <h2
                className="text-2xl font-semibold text-gray-800 mb-4"
                style={{ fontFamily: "'Bebas Neue', sans-serif" }}
              >
                Företagsträning
              </h2>
              <p
                className="text-lg text-gray-600"
                style={{ fontFamily: "'IBM Plex Mono', monospace" }}
              >
                Vi erbjuder skräddarsydd gruppträning för företag som vill
                stärka hälsa och gemenskap på arbetsplatsen. Perfekt för att
                förbättra produktivitet, minska stress och skapa en bättre
                arbetsmiljö.
              </p>
            </div>

            {/* Schedule */}
            <div>
              <h2
                className="text-2xl font-semibold text-gray-800 mb-4"
                style={{ fontFamily: "'Bebas Neue', sans-serif" }}
              >
                Gruppträningsschema
              </h2>
              <ul
                className="list-disc list-inside text-lg text-gray-600"
                style={{ fontFamily: "'IBM Plex Mono', monospace" }}
              >
                <li>Måndag: 18:00–19:00</li>
                <li>Torsdag: 18:00–19:00</li>
                <li>Söndag: 17:00–18:00</li>
              </ul>
            </div>

            {/* Booking Call-to-Action */}
            <div
              className="text-center my-16"
              style={{ fontFamily: "'IBM Plex Mono', monospace" }}
            >
              <a
                href="https://www.bokadirekt.se/places/lada-basteskar-60229"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-darkBlue text-white font-semibold py-3 px-8 rounded-md hover:bg-hoverBlue transition duration-200"
              >
                Boka Träning
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Classes;
